import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, Router } from '@angular/router';
import { PageNotFoundComponent } from './shared/misc/page-not-found/page-not-found.component';
import { BUYER_ROLE } from './shared';
import { AuthGuard } from './core/guards/auth.guard';

import { LayoutComponent as MobileLayoutComponent } from './modules/mobile/_layout/layout.component';
import { LayoutComponent as PcLayoutComponent } from './modules/pc/_layout/layout.component';
import { MainComponent as MobileMainComponent } from './modules/mobile/home/main.component';
import { MainComponent as PcMainComponent } from './modules/pc/home/main.component';
import { DeviceDetectorService } from 'ngx-device-detector';

const mobileRoutes: Routes = [
  {
    path: '',
    component: MobileLayoutComponent,
    data: {
      layout: MobileLayoutComponent.COMMON_WITHOUT_GNB_LAYOUT,
    },
    children: [
      {
        path: '',
        component: MobileMainComponent,
      },
    ],
  },
  {
    path: 'home',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/home/home.module').then((m) => m.HomeModule),
    // children: [
    //   {
    //     path: '',
    //     component: MobileHomeComponent,
    //   },
    // ],
  },
  {
    path: 'vi',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/home/home.module').then((m) => m.HomeModule),
    // children: [
    //   {
    //     path: '',
    //     component: MobileHomeComponent,
    //   },
    // ],
  },
  {
    path: 'signup',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/mobile/signup/signup.module').then((m) => m.SignupModule),
  },
  {
    path: 'withdraw',
    component: MobileLayoutComponent,
    data: {
      layout: MobileLayoutComponent.COMMON_WITHOUT_GNB_LAYOUT,
      preload: true,
    },
    loadChildren: () => import('./modules/mobile/withdraw/withdraw.module').then((m) => m.WithdrawModule),
  },
  {
    path: 'signin',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/mobile/signin/signin.module').then((m) => m.SigninModule),
  },
  {
    path: 'find-email',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/mobile/find-email/find-email.module').then((m) => m.FindEmailModule),
  },
  {
    path: 'find-password',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/mobile/find-password/find-password.module').then((m) => m.FindPasswordModule),
  },
  {
    path: 'my',
    canActivate: [AuthGuard],
    data: {
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/my/my.module').then((m) => m.MyModule),
  },
  {
    path: 'cart',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.CLOSED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/cart/cart.module').then((m) => m.CartModule),
  },
  {
    path: 'order',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.CLOSED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/order/order.module').then((m) => m.OrderModule),
  },
  {
    path: 'category',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/category/category.module').then((m) => m.CategoryModule),
  },
  {
    path: 'product',
    canActivate: [AuthGuard],
    data: {
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/product/product.module').then((m) => m.ProductModule),
  },
  {
    path: 'new-arrivals',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.CLOSED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/new-arrivals/new-arrivals.module').then((m) => m.NewArrivalsModule),
  },
  {
    path: 'best-sellers',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.CLOSED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/best-sellers/best-sellers.module').then((m) => m.BesetSellersModule),
  },
  {
    path: 'best',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/best/best.module').then((m) => m.BestModule),
  },
  {
    path: 'brand',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/brand/brand.module').then((m) => m.BrandModule),
  },
  {
    path: 'umma-pick',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/umma-pick/umma-pick.module').then((m) => m.UmmaPickModule),
  },
  {
    path: 'u-quick',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () =>
      import('./modules/mobile/rocket-delivery/rocket-delivery.module').then((m) => m.RocketDeliveryModule),
  },
  {
    path: 'u-direct',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/europe-direct/europe-direct.module').then((m) => m.EuropeDirectModule),
  },
  {
    path: 'a-direct',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/mobile/america-direct/america-direct.component').then((m) => m.AmericaDirectComponent),
      },
    ],
  },
  {
    path: 'clean-beauty',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/clean-beauty/clean-beauty.module').then((m) => m.CleanBeautyModule),
  },
  {
    path: 'cpnp',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/cpnp/cpnp.module').then((m) => m.CpnpModule),
  },
  {
    path: 'u-outlet',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/clearance/clearance.module').then((m) => m.ClearanceModule),
  },
  {
    path: 'u-box',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/u-box/u-box.module').then((m) => m.UBoxModule),
  },
  {
    path: 'search',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.COMMON_FOOTER_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'promotion',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.CLOSED_WITH_GNB_NONE_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/mobile/promotion/promotion.module').then((m) => m.PromotionModule),
  },
  {
    path: 'promotion-notice',
    component: MobileLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: MobileLayoutComponent.OPENED_WITH_GNB_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () =>
      import('./modules/mobile/promotion-notice/promotion-notice.module').then((m) => m.PromotionNoticeModule),
  },
  {
    path: 'policy',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/resp/policy/policy.module').then((m) => m.PolicyModule),
  },
  {
    path: 'reset-password',
    component: MobileLayoutComponent,
    loadChildren: () =>
      import('./modules/resp/reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
  },
  {
    path: 'account-recovery',
    component: MobileLayoutComponent,
    loadChildren: () =>
      import('./modules/resp/account-recovery/account-recovery.module').then((m) => m.AccountRecoveryModule),
  },
  {
    path: 'beginner-guide',
    canActivate: [AuthGuard],
    data: {
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () =>
      import('./modules/mobile/beginner-guide/beginner-guide.module').then((m) => m.BeginnerGuideModule),
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
    data: { error: 404 },
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

const pcRoutes: Routes = [
  {
    path: '',
    component: PcLayoutComponent,
    data: {
      layout: PcLayoutComponent.UNAUTHORIZED_LAYOUT,
    },
    children: [
      {
        path: '',
        component: PcMainComponent,
      },
    ],
  },
  {
    path: 'home',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/home/home.module').then((m) => m.HomeModule),
    // children: [
    //   {
    //     path: '',
    //     component: PcHomeComponent,
    //   },
    // ],
  },
  {
    path: 'vi',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/home/home.module').then((m) => m.HomeModule),
    // children: [
    //   {
    //     path: '',
    //     component: PcHomeComponent,
    //   },
    // ],
  },
  {
    path: 'signup',
    component: PcLayoutComponent,
    data: {
      layout: PcLayoutComponent,
    },
    loadChildren: () => import('./modules/pc/signup/signup.module').then((m) => m.SignupModule),
  },
  {
    path: 'withdraw',
    component: PcLayoutComponent,
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
    },
    loadChildren: () => import('./modules/pc/withdraw/withdraw.module').then((m) => m.WithdrawModule),
  },
  {
    path: 'signin',
    component: PcLayoutComponent,
    loadChildren: () => import('./modules/pc/signin/signin.module').then((m) => m.SigninModule),
  },
  {
    path: 'mobile-otp',
    component: PcLayoutComponent,
    data: {
      layout: PcLayoutComponent,
    },
    loadChildren: () => import('./modules/pc/signin/signin.module').then((m) => m.SigninModule),
  },
  {
    path: 'find-email',
    component: PcLayoutComponent,
    loadChildren: () => import('./modules/pc/find-email/find-email.module').then((m) => m.FindEmailModule),
  },
  {
    path: 'find-password',
    component: PcLayoutComponent,
    loadChildren: () => import('./modules/pc/find-password/find-password.module').then((m) => m.FindPasswordModule),
  },
  {
    path: 'my',
    // component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      // layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/my/my.module').then((m) => m.MyModule),
  },
  {
    path: 'cart',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_WITHOUT_FOOTER_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/cart/cart.module').then((m) => m.CartModule),
  },
  {
    path: 'order',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_WITHOUT_FOOTER_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/order/order.module').then((m) => m.OrderModule),
  },
  {
    path: 'category',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/category/category.module').then((m) => m.CategoryModule),
  },
  {
    path: 'product',
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_WITHOUT_FOOTER_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/product/product.module').then((m) => m.ProductModule),
  },
  {
    path: 'new-arrivals',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/new-arrivals/new-arrivals.module').then((m) => m.NewArrivalsModule),
  },
  {
    path: 'best-sellers',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/best-sellers/best-sellers.module').then((m) => m.BesetSellersModule),
  },
  {
    path: 'umma-pick',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/umma-pick/umma-pick.module').then((m) => m.UmmaPickModule),
  },
  {
    path: 'u-quick',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () =>
      import('./modules/pc/rocket-delivery/rocket-delivery.module').then((m) => m.RocketDeliveryModule),
  },
  {
    path: 'u-direct',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/europe-direct/europe-direct.module').then((m) => m.EuropeDirectModule),
  },
  {
    path: 'a-direct',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/pc/america-direct/america-direct.component').then((m) => m.AmericaDirectComponent),
      },
    ],
  },
  {
    path: 'u-outlet',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/clearance/clearance.module').then((m) => m.ClearanceModule),
  },
  {
    path: 'u-box',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/u-box/u-box.module').then((m) => m.UBoxModule),
  },
  {
    path: 'best',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/best/best.module').then((m) => m.BestModule),
  },
  {
    path: 'brand',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/brand/brand.module').then((m) => m.BrandModule),
  },
  {
    path: 'search',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'promotion',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/promotion/promotion.module').then((m) => m.PromotionModule),
  },
  {
    path: 'promotion-notice',
    component: PcLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      layout: PcLayoutComponent.AUTHORIZED_LAYOUT,
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () =>
      import('./modules/pc/promotion-notice/promotion-notice.module').then((m) => m.PromotionNoticeModule),
  },
  {
    path: 'policy',
    component: MobileLayoutComponent,
    loadChildren: () => import('./modules/resp/policy/policy.module').then((m) => m.PolicyModule),
  },
  {
    path: 'reset-password',
    component: PcLayoutComponent,
    loadChildren: () =>
      import('./modules/resp/reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
  },
  {
    path: 'account-recovery',
    component: PcLayoutComponent,
    loadChildren: () =>
      import('./modules/resp/account-recovery/account-recovery.module').then((m) => m.AccountRecoveryModule),
  },
  {
    path: 'beginner-guide',
    canActivate: [AuthGuard],
    data: {
      preload: true,
      roles: [BUYER_ROLE.BUYER_APPROVED],
    },
    loadChildren: () => import('./modules/pc/beginner-guide/beginner-guide.module').then((m) => m.BeginnerGuideModule),
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
    data: { error: 404 },
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(mobileRoutes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      // useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  private router = inject(Router);
  private deviceService = inject(DeviceDetectorService);

  public constructor() {
    const router = this.router;
    const deviceService = this.deviceService;

    if (!(deviceService.isMobile() || deviceService.isTablet())) {
      router.resetConfig(pcRoutes);
    }
  }
}
